import React, { useEffect } from "react";
import { loadingsShow } from "../../Services/PostAPI";
import companyData from "./tableData.json";
import {
  fetchCompany,
  initializeCompanyScreen,
} from "../../Redux/Actions/company";

import { connect } from "react-redux";
import CompanyComponent from "../../components/Company";
import { APP_URLS } from "../../constants/urlConstants";

const ComapnyScreen = (props) => {
  const {
    history,
    fetchCompany,
    initializeCompanyScreen,
    showPageLevelLoader,
    companyListView,
    paginationCompanyInfo,
    isLoading,
  } = props;
  
  useEffect(() => {
    initializeCompanyScreen();
    fetchCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const createCompanys = () => {
    history.push(APP_URLS.COMPANY.ADD_COMPANY);
  };

  const loadLazyData = (props) => {
    fetchCompany(props);
  };

  const companyProps = {
    createCompanys,
    fetchCompany: loadLazyData,
    ...companyData,
    tableData: {
      ...companyData.tableData,
      rows: companyListView,
    },
    paginationInfo: {
      ...companyData.paginationCompanyInfo,
      pageSize: paginationCompanyInfo?.pageSize,
      pageNumber: paginationCompanyInfo?.pageNumber,
      totalPages: paginationCompanyInfo?.totalPages,
      totalRecords: paginationCompanyInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingsShow("block");
    return null;
  }
  loadingsShow("none");

  return (
    <div>
      <CompanyComponent {...companyProps} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeCompanyScreen: () => dispatch(initializeCompanyScreen()),
    fetchCompany: (payload) => dispatch(fetchCompany(payload)),
  };
};


const selectIsLoading = (companyReducer) => companyReducer.isLoading;
const selectPaginationCumpanyInfo = (companyReducer) =>
  companyReducer.paginationCompanyInfo;
const selectIsLoadingPage = (companyReducer) => companyReducer.isLoadingPage;
const selectIsPageLevelError = (companyReducer) =>
  companyReducer.isPageLevelError;
const selectCompanyList = (companyReducer) => companyReducer.companyListView;



const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    companyListView: selectCompanyList(state.companyReducer),
    showPageLevelLoader: selectIsLoadingPage(state.companyReducer),
    paginationCompanyInfo: selectPaginationCumpanyInfo(state.companyReducer),
    isPageLevelError: selectIsPageLevelError(state.companyReducer),
    isFetchingGridData: selectIsLoading(state.companyReducer),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComapnyScreen);
